module.exports = __webpack_public_path__ + "img/1.725f24e0.jpg";